import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import Modal from 'react-responsive-modal'
import FormatMoney from '../../Utils/FormatMoney'
import EllipsisModal from '../../Components/EllipsisModal'
import EcommerceProductActions from '../../Redux/EcommerceProductRedux'
import CategoryActions from '../../Redux/CategoryRedux'
import BrandActions from '../../Redux/BrandRedux'
import SupplierActions from '../../Redux/SupplierRedux'
import CreateEcommerceProduct from '../../Containers/Ecommerce/CreateEcommerceProduct'
import UpdateEcommerceProduct from '../../Containers/Ecommerce/UpdateEcommerceProduct'
import { currentBranch } from '../../Utils/PrivilegeUtils'
import AddEcommerceStock from '../../Containers/Ecommerce/AddEcommerceStock'
import Toggle from 'react-toggle'

class ManageEcommerceProduct extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'Y-MM-DD'
    this.filterOrigin = [
      { label: 'ALL', value: '', restriction: 'PH' },
      { label: 'Passpod ID', value: 'ID', restriction: 'PH' },
      { label: 'Passpod PH', value: 'PH' }
    ]
    this.state = {
      showModal: null,
      errorMsg: '',
      detail: {},
      page: 1,
      ecommerceProductID: '',
      inventoryID: '',
      inventoryName: '',
      selectedSize: {
        value: '',
        label: ''
      },
      selectedColour: {
        value: '',
        label: ''
      },
      selectedWarehouse: {
        value: '',
        label: ''
      },
      filter: {
        page: 1,
        title: '',
        category: '',
        brand: '',
        supplier: '',
        iso_code: ''
      }
    }
  }

  componentDidMount = () => {
    this._fetchInventory()
    this.props.getCategory()
    this.props.getSupplier()
    this.props.getBrand()
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.ecommerceProduct.err !== prevProps.ecommerceProduct.err && this.props.ecommerceProduct.err !== null) {
      this.setState({ errorMsg: this.props.ecommerceProduct.err })
    }
  }

  _fetchInventory = (event) => {
    if (event) { event.preventDefault() }
    let data = { ...this.state.filter }
    this.props.getEcommerceProduct(data)
  }

  _filterChange = (data, field) => {
    let filter = { ...this.state.filter }

    filter[field] = data
    this.setState({ filter })
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter }
    filter.page = page
    this.props.getEcommerceProduct(filter)
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (!modalId) {
      this._fetchInventory()
    }
  }

  _selectItem = (child, parent, action) => {
    if (action === 'update-ecommerce-product') {
      this.setState({
        inventoryID: parent.id,
        selectedSize: {
          value: !child.varian_size ? '' : child.varian_size.id,
          label: !child.varian_size ? '' : child.varian_size.name
        },
        selectedColour: {
          value: !child.varian_colour ? '' : child.varian_colour.id,
          label: !child.varian_colour ? '' : child.varian_colour.name
        },
        selectedWarehouse: {
          value: !child.warehouse ? '' : child.warehouse.id,
          label: !child.warehouse ? '' : child.warehouse.name
        },
        detail: child
      })
      this._toggleModal(action)
    } else if (action === 'delete-ecommerce-product') {
      this.setState({
        inventoryID: parent.id,
        ecommerceProductID: child.id
      })
      this._toggleModal(action)
    } else if (action === 'add-ecommerce-product') {
      this.setState({
        detail: child
      })
      this._toggleModal(action)
    } else if (action === 'view-ecommerce-product') {
      this.setState({
        inventoryID: parent.id,
        ecommerceProductID: child.id,
        inventoryName: parent.name
      })
      this._toggleModal(action)
    }
  }

  _toggleAvailability = (item, ecommerceProductID, inventoryID) => {
    let form = {
      sku_v: item.sku_v,
      warehouse_id: item.warehouse.id,
      availability: undefined
    }
    item.availability === 0 ? form.availability = 1 : form.availability = 0
    let data = { ecommerceProductID, inventoryID, form }
    this.props.updateEcommerceProduct(data)
    setTimeout(() => {
      this._fetchInventory()
    }, 300)
  }

  _deleteEcommerceProduct = () => {
    let payload = {
      inventoryID: this.state.inventoryID,
      ecommerceProductID: this.state.ecommerceProductID
    }
    this.props.deleteEcommerceProduct(payload)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _manipulateState = (props) => {
    let filter = { ...props }
    filter.page = this.state.filter.page
    this.setState({ filter })
  }

  render () {
    const { ecommerceProduct } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Manage Product
              {
                (ecommerceProduct.fetching || ecommerceProduct.processing) &&
                <div className='badge badge-info ml-2'>{ ecommerceProduct.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
          </div>
          <form className='form-inline' onSubmit={(event) => this._fetchInventory(event)}>
            <div className='form-group mr-2 mb-3'>
              <label className='control-label mr-2'>Search</label>
              <input style={{ width: '250px' }} type='text' placeholder='Product Title' className='form-control' value={this.state.filter.title} onChange={(event) => this._filterChange(event.target.value, 'title')} />
            </div>
            <div className='form-group mr-2 mb-3'>
              <label className='control-label mr-2'>Categories</label>
              <select value={this.state.filter.category} className='form-control' onChange={(event) => this._filterChange(event.target.value, 'category')}>
                <option value=''> -- Select Category -- </option>
                {this.props.category.data.map((category, index) => (
                  <option value={category.id} key={index}> {category.name} </option>
                ))}
              </select>
            </div>
            <div className='form-group mr-2 mb-3'>
              <label className='control-label mr-2'>Brand</label>
              <select value={this.state.filter.brand} className='form-control' onChange={(event) => this._filterChange(event.target.value, 'brand')}>
                <option value=''> -- Select Brand -- </option>
                {this.props.brand.data.map((brand, index) => (
                  <option value={brand.id} key={index}> {brand.name} </option>
                ))}
              </select>
            </div>
            <div className='form-group mr-2 mb-3'>
              <label className='control-label mr-2'>Supplier</label>
              <select value={this.state.filter.supplier} className='form-control' onChange={(event) => this._filterChange(event.target.value, 'supplier')}>
                <option value=''> -- Select Supplier -- </option>
                {this.props.supplier.data.map((supplier, index) => (
                  <option value={supplier.id} key={index}> {supplier.name} </option>
                ))}
              </select>
            </div>
            <div className='form-group mr-2 mb-3'>
              <label className='control-label mr-2'>Origin</label>
              <select value={this.state.filter.iso_code} className='form-control' onChange={(event) => this._filterChange(event.target.value, 'iso_code')}>
                {this.filterOrigin.map((origin, index) => {
                  if (origin.restriction !== currentBranch()) {
                    return <option value={origin.value} key={index}> {origin.label} </option>
                  } else {
                    return false
                  }
                })}
              </select>
            </div>
            <div className='form-group mr-2 mb-2'>
              <button type='submit' className='btn btn-primary'>Apply Filter</button>
            </div>
          </form>
        </header>
        <section className='section'>
          <div className='card'>
            {
              !(ecommerceProduct.fetching || ecommerceProduct.processing) && ecommerceProduct.err &&
              <div className='alert alert-danger'>{ecommerceProduct.err}</div>
            }
            {
              this.state.errorMsg &&
              <div className='alert alert-danger'>{this.state.errorMsg}</div>
            }
            <div className='card-block'>
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    <th className='text-center'>Inventory Data</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    !ecommerceProduct.data.data || !ecommerceProduct.data.data.length
                      ? <tr>
                        <td colSpan='12' className='text-center'>No data</td>
                      </tr>
                      : ecommerceProduct.data.data.map((items, i) => (
                        <tr key={i}>
                          <td className='align-middle'>
                            <div className='mt-2 mb-2'>
                              <h6>
                                <button data-toggle='collapse' data-target={`#collapse-${i}`} className='btn btn-info mr-2' type='button'>
                                  <i className='fa fa-eye' /> Variants
                                </button>
                                <strong>{items.name}</strong>
                              </h6>
                            </div>
                            <div>
                              <table className='table-bordered'>
                                <thead>
                                  <tr>
                                    <th className='text-center align-middle'>SKU Master</th>
                                    <th className='text-center align-middle'>Category</th>
                                    <th className='text-center align-middle'>Brand</th>
                                    <th className='text-center align-middle'>Discount Type</th>
                                    <th className='text-center align-middle'>Buy Price</th>
                                    <th className='text-center align-middle'>Normal Price</th>
                                    <th className='text-center align-middle'>Final Price</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className='text-center align-middle'>{ items.sku_m || '-' }</td>
                                    <td className='text-center align-middle'>{ items.category.name || '-' }</td>
                                    <td className='text-center align-middle'>{ items.brand.name || '-' }</td>
                                    <td className='text-center align-middle'>{ items.discount_type || '-' }</td>
                                    <td className='text-center align-middle'>{ FormatMoney(items.buy_price) || '-' }</td>
                                    <td className='text-center align-middle'>{ FormatMoney(items.normal_price) || '-' }</td>
                                    <td className='text-center align-middle'>{ FormatMoney(items.final_price) || '-' }</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <br />
                            <div className='collapse' id={`collapse-${i}`}>
                              <div className='mt-2 mb-2'>
                                <button className='btn btn-primary text-center' onClick={() => this._selectItem(items, null, 'add-ecommerce-product')}>
                                  <i className='fa fa-plus' /> Add Variant
                                </button>
                              </div>
                              <div className='table-responsive'>
                                <table className='table-bordered'>
                                  <thead>
                                    <tr>
                                      <th className='text-center align-middle'>SKU Variant</th>
                                      <th className='text-center align-middle'>In Stock</th>
                                      <th className='text-center align-middle'>Price</th>
                                      <th className='text-center align-middle'>Buy Price</th>
                                      <th className='text-center align-middle'>Type</th>
                                      <th className='text-center align-middle'>Subtype</th>
                                      <th className='text-center align-middle'>Vending Machine ID</th>
                                      <th className='text-center align-middle'>Warehouse</th>
                                      <th className='text-center align-middle'>Available</th>
                                      <th className='text-center align-middle'>Stock History</th>
                                      <th className='text-center align-middle'>Edit</th>
                                      <th className='text-center align-middle'>Delete</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      !items.inventory_items || !items.inventory_items.length
                                        ? <tr className='text-center'>
                                          <td colSpan='13'> --No Data-- </td>
                                        </tr>
                                        : items.inventory_items.map((item, i) => (
                                          <tr key={i}>
                                            <td className='text-center align-middle'>{ item.sku_v || 'No data' }</td>
                                            <td className='text-center align-middle'>{ item.itemIn - item.itemOut || '-' }</td>
                                            <td className='text-center align-middle'>{ FormatMoney(item.price) || '-' }</td>
                                            <td className='text-center align-middle'>{ FormatMoney(item.buy_price) || '-' }</td>
                                            <td className='text-center align-middle'>{ item.varian_colour !== null ? item.varian_colour.name : 'No data' }</td>
                                            <td className='text-center align-middle'>{ item.varian_size !== null ? item.varian_size.name : 'No data' }</td>
                                            <td className='text-center align-middle'>
                                              { item.vm_product_id ? item.vm_product_id : '-' }
                                            </td>
                                            <td className='text-center align-middle'>
                                              <EllipsisModal
                                                type='array'
                                                descriptor='Warehouse'
                                                name={item.warehouse.name}
                                                description={[
                                                  {
                                                    label: 'Address: ',
                                                    content: item.warehouse.address
                                                  },
                                                  {
                                                    label: 'Details: ',
                                                    content: item.warehouse.detail_info
                                                  }
                                                ]}
                                              />
                                            </td>
                                            <td className='text-center align-middle'>
                                              <Toggle checked={item.availability === 1} onChange={() => this._toggleAvailability(item, item.id, items.id)} />
                                            </td>
                                            <td className='text-center align-middle'>
                                              <button className='text-center btn btn-info align-middle' onClick={() => this._selectItem(item, items, 'view-ecommerce-product')}>
                                                <i className='fa fa-book' />
                                              </button>
                                            </td>
                                            <td className='text-center align-middle'>
                                              <button className='text-center btn btn-primary align-middle' onClick={() => this._selectItem(item, items, 'update-ecommerce-product')}>
                                                <i className='fa fa-edit' />
                                              </button>
                                            </td>
                                            <td className='text-center align-middle'>
                                              <button className='text-center btn btn-danger align-middle' onClick={() => this._selectItem(item, items, 'delete-ecommerce-product')}>
                                                <i className='fa fa-trash' />
                                              </button>
                                            </td>
                                          </tr>
                                        ))
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <section className='text-center'>
          {
            (ecommerceProduct.data && ecommerceProduct.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={ecommerceProduct.data.page || this.state.page}
              itemsCountPerPage={10}
              totalItemsCount={ecommerceProduct.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'add-ecommerce-product'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateEcommerceProduct
            detail={this.state.detail}
            closeModal={() => this._toggleModal()}
          />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view-ecommerce-product'} onClose={this._toggleModal} closeOnOverlayClick>
          <AddEcommerceStock
            inventoryID={this.state.inventoryID}
            ecommerceProductID={this.state.ecommerceProductID}
            inventoryName={this.state.inventoryName}
            closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-ecommerce-product'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateEcommerceProduct
            detail={this.state.detail}
            inventoryID={this.state.inventoryID}
            selectedSize={this.state.selectedSize}
            selectedColour={this.state.selectedColour}
            selectedWarehouse={this.state.selectedWarehouse}
            closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal center open={this.state.showModal === 'delete-ecommerce-product'} onClose={this._toggleModal} closeOnOverlayClick>
          <section className='section' style={{ width: '30vw' }}>
            <div className='title-block'>
              <h3 className='title'>Delete product</h3>
            </div>
            <div className='d-flex justify-content-center'>
              <button className='btn btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
              <button className='btn btn-danger' onClick={() => this._deleteEcommerceProduct()}>Delete</button>
            </div>
          </section>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  ecommerceProduct: state.ecommerceProduct,
  category: state.category,
  supplier: state.supplier,
  brand: state.brand
})

const dispatchToProps = (dispatch) => ({
  getEcommerceProduct: (filter) => dispatch(EcommerceProductActions.getEcommerceProductRequest(filter)),
  updateEcommerceProduct: (data) => dispatch(EcommerceProductActions.updateEcommerceProductRequest(data)),
  deleteEcommerceProduct: (payload) => dispatch(EcommerceProductActions.deleteEcommerceProductRequest(payload)),
  getCategory: (data) => dispatch(CategoryActions.getCategoryRequest(data)),
  getSupplier: (filter) => dispatch(SupplierActions.getSupplierRequest(filter)),
  getBrand: (filter) => dispatch(BrandActions.getBrandRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(ManageEcommerceProduct)



// WEBPACK FOOTER //
// ./src/Pages/Ecommerce/ManageEcommerceProduct.js